import { render, staticRenderFns } from "./TalkWithGuide.vue?vue&type=template&id=7dcda081&"
import script from "./TalkWithGuide.vue?vue&type=script&lang=js&"
export * from "./TalkWithGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports